module.exports = __webpack_public_path__ + "static/bathroom_dark-f146a31e5db34fcf5baa2b8eb18b8cda.jpg";